export default "__VITE_ASSET__RvGm_Pde__"